// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cYM6iC4{display:grid;grid-template-columns:1.5em 1fr;padding:1em 1.25em;border-radius:1em;background:#fff;gap:1em}@media(max-width: 899px){.cYM6iC4{padding:1em}}.cYM6iC4:not(:last-child){margin-bottom:1em}@media(max-width: 899px){.cYM6iC4:not(:last-child){margin-bottom:.75em}}.mAPUv2L{color:#8168f0}.YtTrpq9,.cYM6iC4 .YtTrpq9{font-family:var(--title-font-family);font-weight:600;line-height:1.375}.pJUzIwW,.cYM6iC4 .pJUzIwW{margin-top:.571em;line-height:1.5;color:var(--gray-and-white-graphite-sber-1, #576875)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cYM6iC4`,
	"icon": `mAPUv2L`,
	"title": `YtTrpq9`,
	"description": `pJUzIwW`
};
export default ___CSS_LOADER_EXPORT___;
